export {
  PromotionResultList,
  PromotionsList
} from '../PromotionResultList'
